<div style="margin: 10px;">
    <div>
        <h1>In Progress Projects</h1>
    </div>
    <div class="panel-margin-table">
        <ag-grid-angular #agGrid style="width: 100%; height: 610px;" [columnDefs]="columnDefs"
                [rowData]="rowData" [paginationPageSize]="10" class="ag-theme-alpine"
                [rowHeight]="50" [pagination]="true"></ag-grid-angular>
    </div>
</div>